import { create } from "zustand";

export const notificationStore = create((set) => ({
  hasNotification: false,

  setHasNotification: (data) => {
    set(() => ({ hasNotification: data }));
  },
}));
